import api from "PFCore/api";
import { ProjectsResponse } from "PFCore/hooks/queries/bookings/projects/use_projects_entries";
import { QueryParams } from "PFTypes";

export type FetchProjectsRolesParams = QueryParams;

export const fetchProjectsEngagements = (data: FetchProjectsRolesParams) =>
  api<ProjectsResponse>({
    url: `booking_module/engagements/index`,
    method: "POST",
    data
  });
